import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import './Business.css'
import { Link } from 'react-router-dom'
import ClipLoader from 'react-spinners/ClipLoader'
import Axios from 'axios'
import validator from 'validator'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from './config'

const Business = () => {
  const history = useHistory()

  const [business, setBusiness] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')
  const [response, setResponse] = useState('')
  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [spinning, setSpinning] = useState('none')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [disabled, setDisabled] = useState(false)

  const timeoutRef = useRef(null)

  useEffect(() => {
    document.title = 'Karamale | Organiser registration'

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const showError = (message) => {
    setError(message)
    setErrorDisplay('block')
    setSpinning('none')
    setUpdateDisplay('block')

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  const onSubmitForm = async () => {
    setErrorDisplay('none')
    setResponse('')
    setUpdateDisplay('none')
    setSpinning('block')

    if (business.trim() === '') {
      showError('Enter your business or organiser name.')
      return
    }

    if (email.trim() === '') {
      showError('Enter your email address.')
      return
    }

    if (!validator.isEmail(email.trim())) {
      showError('Your email address is invalid.')
      return
    }

    if (phone.trim() === '') {
      showError('Enter your phone number.')
      return
    }

    if (pass1.length < 8) {
      showError('Password must be at least 8 characters long.')
      return
    }

    if (pass1 !== pass2) {
      showError('Make sure both your passwords match.')
      return
    }

    setDisabled(true)

    const baseURL = `${API_URL}/apps/kscanner/webservices.php?`
    const data = new FormData()

    data.append('account_name', business.trim())
    data.append('phone', phone)
    data.append('email', email.trim())
    data.append('password', pass1)
    data.append('accounttype', 'business')
    data.append('platform', 'web')
    data.append('query', 'VERIFYACCOUNT')

    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status === 'success') {
          localStorage.setItem('verificationAccount', 'BUSINESS')

          history.push({
            pathname: '/verification',
            state: {
              email: email.trim(),
              accounttype: 'business',
              password: pass1,
            },
          })
        } else {
          showError(response.data.message)
          setDisabled(false)
        }
      })
      .catch((error) => {
        console.error(error)
        showError('Something went wrong. Please try again.')
        setDisabled(false)
      })
  }

  return (
    <div className="kx-business-page">
      <div className="kx-business-bg">
        <div className="kx-business-bg__orb kx-business-bg__orb--one" />
        <div className="kx-business-bg__orb kx-business-bg__orb--two" />
        <div className="kx-business-bg__grid" />
        <div className="kx-business-bg__word">KARAMALE</div>
      </div>

      <main className="kx-business">
        <div className="kx-business__wrap">
          {/* LEFT BRANDING */}

          <section className="kx-business__brand">
            <Link to="/" className="kx-business__logo">
              karamale<span>.</span>
            </Link>

            <div className="kx-business__brand-content">
              <span className="kx-business__eyebrow">FOR EVENT ORGANISERS</span>

              <h1>
                Put your
                <strong> event </strong>
                in motion.
              </h1>

              <p>
                Create, sell and manage your events with a ticketing platform built to help
                organisers reach their audience and stay in control.
              </p>

              <div className="kx-business__features">
                <div className="kx-business__feature">
                  <span>01</span>
                  <div>
                    <strong>Sell tickets</strong>
                    <small>Give your audience a simple way to secure their tickets.</small>
                  </div>
                </div>

                <div className="kx-business__feature">
                  <span>02</span>
                  <div>
                    <strong>Manage your events</strong>
                    <small>Keep your event, ticketing and sales activity together.</small>
                  </div>
                </div>

                <div className="kx-business__feature">
                  <span>03</span>
                  <div>
                    <strong>Reach your audience</strong>
                    <small>Build awareness and turn interest into attendance.</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="kx-business__brand-footer">
              Already have an account?
              <Link to="/login">Log in</Link>
            </div>
          </section>

          {/* REGISTRATION PANEL */}

          <section className="kx-business__panel">
            <div className="kx-business__card">
              <div className="kx-business__card-head">
                <span className="kx-business__card-kicker">ORGANISER ACCOUNT</span>

                <h2>Start selling with Karamale</h2>

                <p>Create your organiser account and start building your next event.</p>
              </div>

              <div className="kx-business__form">
                <div className="kx-business__field">
                  <label>Business or organiser name</label>

                  <input
                    type="text"
                    name="business"
                    value={business}
                    placeholder="Your business or organiser name"
                    onChange={(e) => {
                      setBusiness(e.target.value)
                      setErrorDisplay('none')
                    }}
                    autoComplete="organization"
                  />
                </div>

                <div className="kx-business__field">
                  <label>Email address</label>

                  <input
                    type="email"
                    name="email"
                    value={email}
                    placeholder="you@example.com"
                    onChange={(e) => {
                      setEmail(e.target.value)
                      setErrorDisplay('none')
                    }}
                    autoComplete="email"
                  />
                </div>

                <div className="kx-business__field">
                  <label>Phone number</label>

                  <PhoneInput
                    country="za"
                    value={phone}
                    onChange={(value) => {
                      setPhone(value)
                      setErrorDisplay('none')
                    }}
                    enableSearch
                    inputStyle={{
                      width: '100%',
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    buttonStyle={{
                      border: 'none',
                      borderRight: '1px solid #e5e5e5',
                      background: '#f7f7f7',
                      borderRadius: '10px 0 0 10px',
                    }}
                    inputProps={{
                      name: 'phone',
                      required: true,
                      autoComplete: 'tel',
                    }}
                  />
                </div>

                <div className="kx-business__row">
                  <div className="kx-business__field">
                    <label>Password</label>

                    <input
                      type="password"
                      value={pass1}
                      placeholder="Minimum 8 characters"
                      onChange={(e) => {
                        setPass1(e.target.value)
                        setErrorDisplay('none')
                      }}
                      autoComplete="new-password"
                    />
                  </div>

                  <div className="kx-business__field">
                    <label>Confirm password</label>

                    <input
                      type="password"
                      value={pass2}
                      placeholder="Repeat your password"
                      onChange={(e) => {
                        setPass2(e.target.value)
                        setErrorDisplay('none')
                      }}
                      autoComplete="new-password"
                    />
                  </div>
                </div>

                <div className="kx-business__terms">
                  By creating an organiser account, you agree to our{' '}
                  <Link to="/terms-conditions" target="_blank">
                    Terms & Conditions
                  </Link>
                  .
                </div>

                <div className="kx-business__error" style={{ display: errorDisplay }}>
                  {error}
                </div>

                <div
                  className="kx-business__response"
                  style={{
                    display: response ? 'block' : 'none',
                  }}
                >
                  {response}
                </div>

                <button
                  type="button"
                  onClick={onSubmitForm}
                  className="kx-business__submit"
                  disabled={disabled}
                >
                  <span style={{ display: updateDisplay }}>
                    Create organiser account
                    <span className="kx-business__submit-arrow">→</span>
                  </span>

                  <span style={{ display: spinning }}>
                    <ClipLoader color="#ffffff" loading={true} size={20} />
                  </span>
                </button>
              </div>

              <div className="kx-business__login">
                <span>Already have an account?</span>

                <Link to="/login">
                  Log in
                  <span>→</span>
                </Link>
              </div>

              <div className="kx-business__back">
                <Link to="/">← Back to Karamale</Link>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}

export default Business
